// extracted by mini-css-extract-plugin
var _1 = "OSHDI__form";
var _2 = "OSHDI__ui";
export { _1 as "form", _2 as "ui" }
